import { render, staticRenderFns } from "./UserBusiness.vue?vue&type=template&id=f7a2d88c&scoped=true&"
import script from "./UserBusiness.vue?vue&type=script&lang=js&"
export * from "./UserBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a2d88c",
  null
  
)

export default component.exports